const dataServers = {
  oasis: {
    baseUrl: process.env.REACT_APP_MIDDLEWARE_URL,
    authServer: true,
    default: true
  }
};

export default dataServers;
